/*	Permet l'ajout de 2 paramètres à la fonction console.log():
	- $bg : couleur de fond du message
	- $color : couleur du texte du message
*/
(function () {
    consoleLog = function ($message, $bg, $color) {
        console.log('%c' + $message, 'background-color:' + $bg + '; color:' + $color + ';padding:3px 5px;');
    };
})();

// /*	Affiche un message personnalisé dans la console */
consoleLog( ' ' );
consoleLog( 'Fabriqué à Lyon par Mcube', '#FA3348', '#ffffff' );
console.log( 'www.mcube.fr' );
consoleLog( ' ' );